function About() {
  return <main>
    <section className="about">

      <section className="about_banner">
        <div className="container h-100">
          <div className="banner_text">
            <p>“Treat your customer as you would treat and serve your father. Imbibing this one principle
              changes the very way a Wealth Manager approaches and suggests the solution to a client.”</p>
            <p>~ Sanjiv Bajaj</p>
          </div>
        </div>
      </section>

      <section className="own_story">
        <div className="container">
          <div className="own_story_data">
            <div className="heading">
              <h2>WRITE YOUR OWN SUCCESS STORY WITH BAJAJ CAPITAL INSURANCE</h2>
            </div>
            <div className="content">
              <p>Bajaj Capital Insurance Broking Limited (“BCIBL”) a company incorporated under the provisions
                of the Companies Act, 1956, was granted the licence (Licence No. 241, Licence Code
                CB042/02) to act as an Insurance Broker by the Insurance Regulatory and Development
                Authority <a href="#">(“IRDA”)</a> in the year 2004 and is in the business
                of insurance broking since then
                and has served over six lakh clients.
                bajajcapitalinsurance.com is owned and operated by Bajaj
                Capital Insurance Broking Limited
                and it is one of India's most prominent insurance comparison, transaction and service
                portal.
              </p>
              <p>
                We offer a wide range of insurance products comprising both life and general insurance. You
                get free insurance quotes, you can compare plans based on their features and also make
                purchases online (as available from time to time).
              </p>
              <p>
                <a href="#">bajajcapitalinsurance.com</a> helps you in comparing different
                plans by providing their quotes
                from insurance companies, list of hospitals covered and key benefits side by side. You can
                compare term life insurance plans, health insurance or mediclaim plans, car insurance and
                travel insurance as well.
              </p>
            </div>
            <div className="buttons">
              <a className="btn button" href="./">Login</a>
              <a href="https://pos.bajajcapitalinsurance.com/" target="_blank"
                className="btn outline_button">Earn with Us</a>
            </div>
          </div>
        </div>
      </section>

      <section className="our-leader">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h3 className="heading">MEET OUR LEADERS</h3>
              <div className="row">
                <div className="col-md-6 text-center">
                  <img src="/assets/images/sanjiv_bajaj.png" className="img-fluid" alt="sanjiv_bajaj" />
                  <p className="name">Mr. Sanjiv Bajaj</p>
                  <small className="designation">(Director)</small>
                </div>
                <div className="col-md-6 text-center">
                  <img src="/assets/images/venkatesh_naidu.png" className="img-fluid" alt="venkatesh_naidu" />
                  <p className="name">Mr. Venkatesh Naidu</p>
                  <small className="designation">(Director & CEO)</small>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="details">
                <img src="/assets/images/icons/quote2.svg" className="quote" alt="quote" />
                <ul>
                  <li><strong>The Group has always looked upon every investor as a valued individual, who
                    offer great opportunity to build a lasting relationship.</strong> The Group has
                    always kept a close tab on the emerging possibilities, and is always on the lookout
                    for offering better value, higher security and greater satisfaction to its clients.
                  </li>
                  <li><strong>Our client’s are not just a phone or identification number for us.</strong>
                    We share a much
                    deeper commitment with them. In fact, in numerous cases, three generations of a
                    family are associated with the Group.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <p className="content">
            You can select your ideal insurance plan from a number of suitable options on a single
            client-oriented platform.<br />
            Our belief lies in ensuring maximum level of client satisfaction by providing them with correct
            information about every insurance product combined with emphasis on specialised advisory on any type
            of insurance solutions throughout leading to higher financial security.<br />
            We show updated quotes, making it easier and simpler for you to choose the perfect insurance
            plan.<br />
            BCIBL is part of the Bajaj Capital Group (“Group”), with <a href="#">Bajaj Capital
              Limited</a> (“BCL”) being the
            flagship company within the Group and is one of the renowned business house, in operation for over
            five decades.<br />
            The Group has varied business interest like financial planning, investment advisory, distribution of
            financial products like mutual funds, fixed income products, depository participant operations, NPS
            distribution, insurance, stock broking, advisory on real estate products etc.
          </p>

          <p className="content">
            Another area that the Group has pioneered in is “investor education”. Through its monthly
            magazine/publication, “Investors India” and a series of other publications like Tax Planning Guide,
            Financial Planning Guide, Money Multiplying News etc., which are highly respected in the field, the
            investor population at large are offered value added financial information, encouraging them,
            empowering them to make judicious and informed investment decisions. Together with that, we have a
            tradition of guiding after balancing of investment goals, risk tolerance and time horizon has
            created the unique structure of need-based selling, which ultimately helps the Client reach his/her
            financial goal(s). In other words, the Group’s motto is ‘Empowering investors to attain their
            financial goals through proper Financial Planning.’
          </p>
          <p className="content">
            In the world of finance, it’s the prepared mind that clinches the opportunity, a three-sixty degree
            awareness, so to speak. The Group’s resource of human expertise is comparable with the best in the
            industry. Belonging to different states of India and strategically placed at various centers to
            ensure perfect communication in local languages. We understand the investors’ needs, desire,
            culture, financial resources, risk-taking capacity, investment habits, and suggest the appropriate
            investment mix through our financial planning approach. Truly, the Group speaks all languages as its
            people are from all walks of life and spread over the entire country.
          </p>
        </div>

      </section>

      <section className="capital">
        <div className="container">
          <div className="heading">
            <h3>WHY BAJAJ CAPITAL INSURANCE?</h3>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="cap-card">
                <img src="/assets/images/icons/capital-1.svg" alt="capital" />
                <div className="cap-data">
                  <h3 className="heading">Superior Insurance Assistance</h3>
                  <p className="text">Guidance from broker qualified persons for approzpriate product
                    selection. We are
                    there whenever you need us</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="cap-card">
                <img src="/assets/images/icons/capital-2.svg" alt="capital" />
                <div className="cap-data">
                  <h3 className="heading">Intelligent recommendations</h3>
                  <p className="text">We are committed to get you the right product by understanding your
                    requirements better</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="cap-card">
                <img src="/assets/images/icons/capital-3.svg" alt="capital" />
                <div className="cap-data">
                  <h3 className="heading">Hassle-free claim settlement</h3>
                  <p className="text">We've worked hard to make paperwork hassle free and assure to assist you
                    in the negotiation of claims</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </main>;;
}

export default About;
